import { render } from "./CompanyDashboard.vue?vue&type=template&id=5d121b5e&scoped=true"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js"

import "./CompanyDashboard.vue?vue&type=style&index=0&id=5d121b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d121b5e"]])

export default __exports__